<template>
  <div> 
       <Header />

       <div class="md-layout md-alignment-center">
         <div class="md-layout-item md-size-50">
           <h1>Transações</h1>
              <Search @search="search" />
             <Table :data="items" />
         </div>
       </div>
  </div>
</template>

<script>


import Header from '@/components/HeaderCompany.vue'

import Table from './components/Table.vue'
import Search from './components/Search.vue';

 
import {mapActions,  mapState } from 'vuex'

import moment from 'moment';


export default {
  components: {
    Header,
    Table,
    Search,
  },
  computed:{
     ...mapState("CompanyTransaction", ["items","totalItems"])
  },
  methods:{    
    ...mapActions("CompanyTransaction", ["findAll"]),
    search(payload){

        const params = Object.assign({},payload)

        if(params.startDate && params.endDate){

          params.startDate = moment(params.startDate).format("YYYY-MM-DD")
          params.endDate = moment(params.endDate).format("YYYY-MM-DD")
        }
        this.findAll(params)  

    },      
  },
  mounted(){    
       this.findAll()  
  }
}
</script>
